<nz-modal 
	[(nzVisible)]="isVisible" 
	[nzFooter]="modalFooter"
	[nzTitle]="title" 
	(nzOnCancel)="handleCancel()" 
	(nzOnOk)="handleOk()" 	
	nzMaskClosable="false"> 
	<nz-upload
		[(nzFileList)]="fileList"
		[nzBeforeUpload]="beforeUpload"
		(nzChange)="progress($event)">
		<button nz-button>
			<i nz-icon type="upload"></i><span>Seleccione archivo</span>
		</button>
	</nz-upload>	

	<ng-template #modalFooter>		
		<button nz-button nzType="default" (click)="handleCancel()">Cerrar</button>
		<button nz-button nzType="primary" [disabled]="uploadDisabled" (click)="handleUpload()" [nzLoading]="uploading">Subir</button>
	</ng-template>
</nz-modal>